module.exports = __webpack_public_path__ + "static/media/soaked.1c9e690f.svg";